import ListEdition from './ListEdition';

export default ListEdition;
